/** @format */

import React from 'react';
import { Route, Routes } from 'react-router-dom';
import RadiantHome from 'src/components/home';
import Questions from 'src/components/questions';
import Order from 'src/components/order';
import OrderResult from 'src/components/orderRequest';
// import About from 'src/components/about';
import TestPage from 'src/components/views/testpage';
import Landing from 'src/components/_views/landingMain';
import LandingHome from 'src/components/_views/landingMain/home';
import HowTo from 'src/components/_views/landingMain/howTo';
import About from 'src/components/_views/landingMain/about';
import Giga from 'src/components/_views/landingMain/gigachat';
import RadiantWrapper from 'src/components/_views/radiantHome';
import styles from './workArea.module.scss';

export default function WorkArea() {
  return (
    // <div className={styles.workArea}>
    <Routes>
      <Route path="/" element={<Landing />}>
        <Route path="" element={<LandingHome />} />
        <Route path="howTo" element={<HowTo />} />
        <Route path="about" element={<About />} />
        <Route path="giga" element={<Giga />} />
        <Route path="questions/:code" element={<Questions key={'code'} />} />
        <Route
          path="questions"
          element={
            <Questions
              key={'code'}
              spaceGuid="00000001-094f-4010-8085-47fc94bd5be1"
            />
          }
        />
        <Route path="orderRequest" element={<OrderResult />} />
        <Route path="order/:code" element={<Order key={'code'} />} />
      </Route>
      {/* старые страницы */}
      {/* <Route path="/radiant" element={<RadiantWrapper />}>
        <Route path="" element={<RadiantHome />} />
        <Route path="About" element={<About />} />
      </Route> */}
      {/* <Route
        path="/questions/:code/manualcode"
        element={<Questions key={'manualcode'} hasManualCode />}
      /> */}
      <Route path="/VGVzdFBhZ2U=" element={<TestPage />} />
    </Routes>
    // </div>
  );
}
